// static/table_engine_src/app_bootstrap.js
import { installGlobalTableBlur } from "./global/blur.js";
import { installGlobalTableInactiveClass } from "./global/inactive.js";
import {
  createStandaloneTableEngine,
  createTableEngineWebObject,
  installTableEngineOnWindow,
} from "./standalone.js";

// Bundle all TableEngine-related CSS into one output CSS file
import "./styles/index.css";

// Bundle generic minibar controller into the same dist entrypoint.
import "../table_minibar.js";

// Initialize shared popover utilities.
import "./ui/popovers.js";

// Feature modules
import { TableEngineIO as TableIO } from "./plugins/io.js";

// Ensure the globals exist in the bundle
import { TableEngineSigmaBucketsPopover as SigmaBucketsPopover } from "./plugins/sigmaBucketsPopover.js";
import { TableEngineBucketPopoverPlugin as BucketPopoverPlugin } from "./plugins/bucketPopoverPlugin.js";

import { TableEngineTruncatedHeaderTooltips as TruncatedHeaderTooltips } from "./plugins/truncated_header_tooltips.js";

installGlobalTableBlur();
installGlobalTableInactiveClass();

const specRegistry = (window.TABLE_SPECS = window.TABLE_SPECS || {});

const tableEngine = createStandaloneTableEngine({
  specRegistry,
  installWindowExports: true,
});

try {
  tableEngine.registerPlugin(BucketPopoverPlugin);
} catch (e) {
  console.warn("TableEngine.registerPlugin(BucketPopoverPlugin) failed:", e);
}

installTableEngineOnWindow(tableEngine, {
  globalObject: window,
  io: TableIO,
  extraGlobals: {
    TableEngineSigmaBucketsPopover: SigmaBucketsPopover,
    TableEngineBucketPopoverPlugin: BucketPopoverPlugin,
    TableEngineTruncatedHeaderTooltips: TruncatedHeaderTooltips,
  },
});

const mbbPlugins = Object.freeze({
  sigmaBucketsPopover: SigmaBucketsPopover,
  truncatedHeaderTooltips: TruncatedHeaderTooltips,
  bucketPopoverPlugin: BucketPopoverPlugin,
});

const tableWeb = createTableEngineWebObject({
  tableEngine,
  specRegistry,
  io: TableIO,
  plugins: mbbPlugins,
});

const tableWebWithUi = Object.freeze({
  ...tableWeb,
  get minibar() {
    return window.MbbTableMinibar || null;
  },
});

window.TableEngineWeb = tableWebWithUi;

export { tableEngine as TableEngine };
